import React from 'react';
import classNames from 'classnames';
interface SpinnerProps {
  size?: 'small' | 'large' | 'normal';
  show: boolean;
  spinnerAlignment?: 'right';
}

const Spinner = (props: SpinnerProps) => (
  <div
    className={classNames({
      'overlay-spinner': true,
      'overlay-spinner__small': props.size === 'small' && props.show,
      'overlay-spinner__large': props.size === 'large' && props.show,
      'overlay-spinner__normal': props.size === 'normal' && props.show,
      'hide-spinner': !props.show
    })}
  >
    <span
      className={classNames({
        'custom-spinner': true,
        'custom-spinner__right': props.spinnerAlignment === 'right'
      })}
    />
  </div>
);

Spinner.deftaultProps = {
  size: 'normal'
};

export default Spinner;
